"use client"

import { UNIVERSAL_LINK_STORE_URL } from "@/_constant/constant"
import { useEffect } from "react"
import ErrorPageLayout from "@/app/components/ErrorState/Error/ErrorPageLayout"
import { reportClientEvent } from "@/lib/observability/client-error-reporter"
import { nativeBr } from "@/utils/nativeBr"
import { useRouter } from "next/navigation"

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const router = useRouter()

  useEffect(() => {
    reportClientEvent("next.global-error", {
      error,
      digest: error.digest,
    })
  }, [error])

  const handleGoHome = () => {
    if (window.location.pathname === "/") {
      if (!nativeBr.isEnabled) {
        router.push(UNIVERSAL_LINK_STORE_URL)
        return
      }

      void nativeBr.dismiss()
      return
    }

    router.push("/")
  }

  return (
    <html lang="ko">
      <body className="flex min-h-svh bg-rl-secondary_gray-scale-bg-01">
        <ErrorPageLayout
          isNavigation={false}
          icon="/images/illustrations/empty/graphic_empty_08.webp"
          title="오류가 발생했습니다."
          desc="홈으로 이동해 다시 이용해주세요."
          button="홈으로 이동"
          onButtonClick={handleGoHome}
        />
      </body>
    </html>
  )
}
